<div class="product-details-tab">
    <ul ngbNav #nav="ngbNav" class="justify-content-center nav nav-pills">
        <li ngbNavItem>
            <a ngbNavLink>
                Description
            </a>
            <ng-template ngbNavContent>
                <div class="product-desc-content">
                    <h3>Product Information</h3>
                    <p class="pb-1 product-desc-content" [innerHTML]= "product.description">                                       
                </div>
            </ng-template>
        </li>
        <li ngbNavItem>
            <a ngbNavLink>
                Delivery information
            </a>
            <ng-template ngbNavContent>
                <div class="product-desc-content" [innerHTML]="apiService.productDeliveryInfo"> 
                </div>
            </ng-template>
        </li>
        <li ngbNavItem>
            <a ngbNavLink>
                Returns & Cancellation Policy
            </a>
            <ng-template ngbNavContent>
                <div class="product-desc-content" [innerHTML]="apiService.productCancellationReturnInfo">                   
                </div>
            </ng-template>
        </li>   
</ul>
    <div [ngbNavOutlet]="nav"></div>
</div>